<template>
  <OwnCard class="selector-card" row :control="!disabled" @click.stop="onClick">
    <div class="w-full" :class="[selected && 'bg-opacity-50 bg-bluetiful-300']">
      <slot></slot>
    </div>
  </OwnCard>
</template>

<script>
import { OwnCard } from '@/ui'

export default {
  name: 'SelectorCard',
  components: { OwnCard },
  props: {
    /** Disables the card */
    disabled: { type: Boolean, default: false },

    /** The card is currently selected */
    selected: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (this.disabled) return

      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.selector-card {
  overflow: hidden;
  border: 1px solid $background-divider;
  cursor: pointer;
}
</style>
